import UrgentModal from "@/components/common/Modal/UrgentModal";

import { Box, useDisclosure } from "@chakra-ui/react";
import { Button, ColorIcon, colors, customEvent, HStack, VStack } from "goi_common";
import SangjoCompareQuotationRequest from "./components/MatchRequest/SangjoCompareQuotationRequest";

export default function RequestQuestionUniqueStep() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <VStack alignItems="center">
      <VStack id="wrapper" width="100%" maxWidth="480px">
        <UrgentModal onClose={onClose} isOpen={isOpen} />
        <VStack gap="10px" padding="18px 24px 24px">
          <HStack alignItems="center" justifyContent="space-between">
            <Box className="head2_b black">2. 상조 비교하기</Box>
            <Button
              style={{
                borderRadius: 16,
                backgroundColor: colors.orange100,
                padding: "10px 14px",
              }}
              onClick={() => {
                customEvent({
                  newGtm: {
                    path: "match_request",
                    trigger_and_target: "quick_cnslt-opn_urgnt_mdl",
                  },
                });
                onOpen();
              }}
            >
              <HStack alignItems="center" gap={10}>
                <ColorIcon name="icon-call-mono" color={colors.orange650} width={16} height={16} />
                <div className="button_14_sb orange700">빠른 상담</div>{" "}
                <ColorIcon name="icon-arrow-right-small-mono" color={colors.orange700} size={12} />
              </HStack>
            </Button>
          </HStack>
        </VStack>
        <SangjoCompareQuotationRequest />
      </VStack>
    </VStack>
  );
}
